module.exports = __webpack_public_path__ + "static/media/8.0ebb5cb2.jpg";